import { Nudge } from './types';

interface NavigateToJFSNudgeStackOptions {
  nudges: Nudge[];
  returnRoute: string;
  setCurrentRoute: (route: string) => void;
  setNudgesData?: (data: any) => void;
  // Nudge to show first; the rest follow in their usual order
  initialNudgeId?: string;
  config?: {
    allowSwipe?: boolean;
    showActionButtons?: boolean;
    header?: {
      visible?: boolean;
      showNumberOfNudgesLeft?: boolean;
      showResetIconButton?: boolean;
      showUndoButton?: boolean;
      showCloseButton?: boolean;
    };
    stackEnd?: {
      showReset?: boolean;
      emoji?: string;
      heading?: string;
    };
  };
}

let jfsNudgesData: any = null;

export const getJFSNudgesData = () => jfsNudgesData;

// Consumed once so a later entry into the stack doesn't reuse it
export const clearJFSInitialNudgeId = () => {
  if (jfsNudgesData) {
    jfsNudgesData.initialNudgeId = undefined;
  }
};

export const navigateToJFSNudgeStack = (options: NavigateToJFSNudgeStackOptions) => {
  const {
    nudges,
    returnRoute,
    setCurrentRoute,
    setNudgesData,
    initialNudgeId,
    config = {}
  } = options;

  const jfsNudges = nudges.map(nudge => ({
    ...nudge,
  }));

  jfsNudgesData = {
    nudges: jfsNudges,
    returnRoute,
    initialNudgeId,
    nudgeStackConfig: {
      allowSwipe: config.allowSwipe ?? true,
      showActionButtons: config.showActionButtons ?? false,
      header: {
        visible: config.header?.visible ?? true,
        showNumberOfNudgesLeft: config.header?.showNumberOfNudgesLeft ?? true,
        showResetIconButton: config.header?.showResetIconButton ?? true,
        showUndoButton: config.header?.showUndoButton ?? false,
        showCloseButton: config.header?.showCloseButton ?? true,
        ...config.header
      },
      stackEnd: {
        showReset: config.stackEnd?.showReset ?? true,
        emoji: config.stackEnd?.emoji,
        heading: config.stackEnd?.heading ?? "You're all caught up",
        ...config.stackEnd
      }
    }
  };

  if (setNudgesData) {
    setNudgesData(jfsNudgesData);
  }

  setCurrentRoute('/jfs-nudges');
};